module.exports = __webpack_public_path__ + "static/logo-full-3c1caec93f926b623754bdeaf934dd38.svg";